import { FC } from "react";
import "./style.css";

interface Props {
  version: string;
}

export const ChangelogExists: FC<Props> = ({ version }) => {
  return (
    <div className="changelog-exists">
      <p>
        Changelog for newest version <span>{version}</span> already exists
      </p>
    </div>
  );
};
